import { Component, OnInit, signal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

interface QuestionnaireConfig {
  id: string;
  configName: string;
  trusteeCategory: string;
  author: string;
  creationDate: string;
  lastModified: string;
  modifiedBy: string;
  status: string;
}

@Component({
  selector: 'app-questionnaires-attachments',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    BreadcrumbModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    MultiSelectModule,
    IconFieldModule,
    InputIconModule,
    TagModule,
    TooltipModule,
  ],
  templateUrl: './questionnaires-attachments.component.html',
  styleUrl: './questionnaires-attachments.component.scss',
})
export class QuestionnairesAttachmentsComponent implements OnInit {
  private router = inject(Router);
  private titleService = inject(Title);

  breadcrumbItems = signal<MenuItem[]>([{ label: 'Configurazione questionari e allegati' }]);

  questionnaires = signal<QuestionnaireConfig[]>([]);
  loading = signal<boolean>(false);

  // Filters
  selectedTemplate: any = null;
  selectedCategory: any[] = [];
  selectedAuthor: any = null;
  creationDateFrom: string = '';
  creationDateTo: string = '';
  modificationDateFrom: string = '';
  modificationDateTo: string = '';
  searchId: string = '';
  searchConfigName: string = '';
  searchAuthor: string = '';
  searchModifiedBy: string = '';
  selectedStatus: any = null;

  // Dropdown options
  templateOptions = [{ label: 'Template', value: null }];

  categoryOptions = [
    { label: 'Tutti', value: 'ALL' },
    { label: 'Periti Auto', value: 'PERITI_AUTO' },
    { label: 'Carrozzerie', value: 'CARROZZERIE' },
    { label: 'Medici', value: 'MEDICI' },
    { label: 'Periti RE', value: 'PERITI_RE' },
  ];

  authorOptions = [
    { label: 'Autore', value: null },
    { label: 'Mario Rossi', value: 'MARIO_ROSSI' },
    { label: 'Francesca Rosso', value: 'FRANCESCA_ROSSO' },
    { label: 'Giuseppe Verdi', value: 'GIUSEPPE_VERDI' },
    { label: 'Anna Ferrai', value: 'ANNA_FERRAI' },
  ];

  statusOptions = [
    { label: 'Stato', value: null },
    { label: 'Attivo', value: 'ATTIVO' },
    { label: 'Inattivo', value: 'INATTIVO' },
  ];

  ngOnInit(): void {
    this.titleService.setTitle('Gestione Questionari e Allegati - Portale Fiduciari AXA');
    this.loadQuestionnaires();
  }

  private loadQuestionnaires(): void {
    this.loading.set(true);

    // Mock data based on the image
    const mockData: QuestionnaireConfig[] = [
      {
        id: 'Pes1',
        configName: 'Questionario Periti Auto',
        trusteeCategory: 'Periti Auto',
        author: 'Mario Rossi',
        creationDate: '15/03/2023',
        lastModified: '28/11/2022',
        modifiedBy: 'Laura Bianchi',
        status: 'INATTIVO',
      },
      {
        id: 'Car1',
        configName: 'Vetricultura carrozzeria',
        trusteeCategory: 'Carrozzerie',
        author: 'Giuseppe Verdi',
        creationDate: '22/08/2024',
        lastModified: '05/12/2024',
        modifiedBy: 'Marco Neri',
        status: 'INATTIVO',
      },
      {
        id: 'Med1',
        configName: 'Questionario Medici Legali v1.3',
        trusteeCategory: 'Medici',
        author: 'Anna Ferrai',
        creationDate: '10/01/2023',
        lastModified: '14/06/2023',
        modifiedBy: 'Paolo Conti',
        status: 'ATTIVO',
      },
      {
        id: 'Pes3',
        configName: 'Template Periti RE Completo',
        trusteeCategory: 'Periti RE',
        author: 'Francesca Rosso',
        creationDate: '18/09/2024',
        lastModified: '25/11/2024',
        modifiedBy: 'Giulia Moretti',
        status: 'INATTIVO',
      },
    ];

    this.questionnaires.set(mockData);
    this.loading.set(false);
  }

  getStatusSeverity(status: string): 'success' | 'danger' | 'info' | 'warn' {
    switch (status) {
      case 'ATTIVO':
        return 'success';
      case 'INATTIVO':
        return 'danger';
      default:
        return 'info';
    }
  }

  getStatusLabel(status: string): string {
    return status === 'ATTIVO' ? 'Attivo' : 'Inattivo';
  }

  onViewDetails(questionnaire: QuestionnaireConfig): void {
    console.log('View details for:', questionnaire);
    // Navigate to details or open dialog
  }

  onCreateNew(): void {
    console.log('Create new questionnaire configuration');
    // Navigate to creation form
  }

  onCreateAttachmentConfig(): void {
    this.router.navigate(['/axa/attachment-config']);
  }

  clearFilters(): void {
    this.selectedTemplate = null;
    this.selectedCategory = [];
    this.selectedAuthor = null;
    this.creationDateFrom = '';
    this.creationDateTo = '';
    this.modificationDateFrom = '';
    this.modificationDateTo = '';
    this.searchId = '';
    this.searchConfigName = '';
    this.searchAuthor = '';
    this.searchModifiedBy = '';
    this.selectedStatus = null;
  }
}
